import React from 'react';
import './category.scss';

const Category = ({ value = '' }: { value?: string }) => {
  return (
    <div className="com-category-box">
      {value === 'Culture' ? (
        <>
          <div className="culture-circle" id="culture-circle"></div>
          <span id="text-culture-circle" className="circle-text">
            CULTURE
          </span>
        </>
      ) : value === 'Economy' ? (
        <>
          <div className="economy-circle" id="economy-circle"></div>
          <span id="text-economy-circle" className="circle-text economy-color">
            ECONOMY
          </span>
        </>
      ) : value === 'ESG' ? (
        <>
          <div className="esg-circle" id="esg-circle"></div>
          <span className="circle-text esg-color">ESG</span>
        </>
      ) : value === 'ALL' ? (
        <>
          <div className="trip-circle" id="trip-circle"></div>
          <span className="circle-text all-color">ALL</span>
        </>
      ) : value == 'Business' ? (
        <>
          <div className="business-circle" id="business-circle"></div>
          <span className="circle-text business-color">BUSINESS</span>
        </>
      ) : (
        <>
          <div className="politics-circle" id="politics-circle"></div>
          <span className="circle-text politics-color">POLITICS</span>
        </>
      )}
    </div>
  );
};

export default Category;
